export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'travelTimes';
export const ENTITY_EDIT_ROUTE = 'travel-time/detail';
